import React from 'react';
import { Box } from '@chakra-ui/react';
import { PrivacyPolicy } from '../features/privacy-policy';
import { ScrollToTop } from '../features/navigation';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <Box as="main" flex="1">
      <PrivacyPolicy />
      <ScrollToTop />
    </Box>
  );
};

export default PrivacyPolicyPage;